import { BrowserRouter as Router } from 'react-router-dom';
import Header from 'components/organisms/Header';
import Routes from 'routes';
import Loading from 'components/atoms/Loading';
import ResponseMsg from 'components/atoms/ReponseMsg';
import { useContext, useEffect } from 'react';
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import auth from 'services/auth';
import api from 'services/api';
import normalizeTags from 'components/helpers/normalizeTags';

const App = () => {
  const { user, setUser, loading, setLoading, setTags, setResponseMsg } = useContext(GlobalContext);

  // Sessao recusada pelo backend (token expirado/invalido): encerra a sessao local.
  useEffect(() => {
    api.setUnauthorizedHandler(() => {
      sessionStorage.removeItem('user');
      setUser({ isAuthenticated: false, token: '' });
      setTags([]);
      setResponseMsg({ isVisible: true, error: true, msg: 'Sua sessão expirou. Faça login novamente.' });
    });
    return () => api.setUnauthorizedHandler(null);
  }, [setUser, setTags, setResponseMsg]);

  // As tags so servem ao formulario de cadastro e o endpoint exige login.
  useEffect(() => {
    if (!user?.isAuthenticated) {
      setTags((previous) => (previous.length ? [] : previous));
      return;
    }

    api
      .getTags(user)
      .then((response) => {
        setTags(normalizeTags(response.data.Item));
      })
      .catch((error) => {
        console.error(error);
        setResponseMsg({ isVisible: true, error: true, msg: error.message });
      })
      .finally(() => setLoading(false));
  }, [user, setLoading, setResponseMsg, setTags]);

  useEffect(() => {
    auth
      .login()
      .then((response) => {
        const { error, user } = response;
        if (!error && user?.token) {
          setUser({ isAuthenticated: true, ...user });
        }
      })
      .catch((error) => {
        console.error(error);
        setResponseMsg({ isVisible: true, error: true, msg: error.message });
      });
  }, [setUser, setResponseMsg]);

  return (
    <>
      <div className="app">
        <Router>
          <Header />
          <Routes />
        </Router>
      </div>
      {loading && <Loading />}
      <ResponseMsg />
    </>
  );
};

export default App;
